export default "__VITE_ASSET__BOA15wbz__"